/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var LeadsIcon = createIcon("LeadsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#23AAE2';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: _color,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.95 10.192a1.005 1.005 0 00-.889-.69l-7.386-.462A620.64 620.64 0 0012 9c-.268 0-1.493.013-3.676.04l-7.386.462a1.003 1.003 0 00-.578 1.767l5.542 4.619-1.382 6.916a.997.997 0 00.406 1.014c.32.225.77.237 1.098.034L12 20.174l5.974 3.677a.995.995 0 001.094-.03.999.999 0 00.411-1.017l-1.382-6.916 5.542-4.62a.992.992 0 00.31-1.076Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "4",
    r: "4"
  })));
}, {
  "replaceColor": true
});